<template>
  <div class="position-column">
    <div class="banner">
      <img :src="banners.img">
    </div>
    <van-sticky class="search-box">
      <div class="search" :style="{ background: searchObj.bgcolor }">
        <div class="searchWrap">
          <button @click="onSearch" class="search-bar">
            <img alt src="../../../assets/img/home/search-icon.png" />
            <span>搜索</span>
          </button>
        </div>
      </div>
    </van-sticky>
    <div class="tabs-wrapper" v-if="columnNavs.length">
      <column-tabs
        :nav-titles='navTitle'
        :price-list='priceTitle'
        :nav-list="columnNavs"
        :offset-top="navbarHeight"
        nav-style="padding: 0 0.2rem"
        ref="columnTabs"
      ></column-tabs>
    </div>
    <!-- 回到顶部 -->
    <back-to-top :show-cart="false" />
  </div>
</template>

<script>
import { Sticky } from 'vant'
import api from '../../../utils/api'
import BackToTop from '../../../components/BackToTop.vue'
import ColumnTabs from './RecommendModule.vue'
export default {
  name: 'thcjqytg',
  components: {
    VanSticky: Sticky,
    BackToTop,
    ColumnTabs
  },
  data () {
    return {
      pageTitle: this.$route.meta.title,
      banners: [],
      searchObj: {},
      columnNavs: [],
      navbarHeight: 44,
      priceTitle: [],
      navTitle: []
    }
  },
  created () {},
  mounted () {
    this.init()
  },
  activated () {},
  methods: {
    onSearch () {
      this.$router.push({ name: 'searchPages', query: { title: this.pageTitle } })
    },
    show () {
      this.visible = false
    },
    async init () {
      this.$toast.loading('正在加载...')
      await this.fetchPageVersion()
      this.$toast.clear()
    },
    async fetchPageVersion () {
      const base = 'Spring-Festival'
      const res = await api.getJsonVersion(base)

      this.banners = res[`${base}-1`].data[0]
      this.searchObj = res[`${base}-2`].data[0]
      this.columnNavs = res[`${base}-3`].data.map(item => {
        item.configer = item
        return item
      })
      this.$nextTick(() => {
        this.$refs.columnTabs.getContList(this.columnNavs[0] && [this.columnNavs[0].configer.column], 1)
        let csid = []
        for (let i in this.columnNavs) {
          csid.push(this.columnNavs[i].configer.column)
        }
        sessionStorage.setItem('csid', JSON.stringify(csid))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.search{
  width: 100%;
  height: .88rem;
  padding: 0.14rem 0.24rem;
  box-sizing: border-box;

  .searchWrap {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    font-size: @fz24;
    color: @c80;
    .search-bar {
      width: 100%;
      height: 0.6rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 30px;
      img {
        width: 0.3rem;
        object-fit: contain;
        padding-left: 0.2rem;
        padding-right: 0.1rem;
      }
    }
  }
}
.banner {
  width: 100%;
  max-height: 3.15rem;
  overflow: hidden;
}
::v-deep .search-box .van-sticky--fixed {
  z-index: 100;
}
</style>
